<template>
  <div>
    <main-layout>
      <v-container>
        <h1 class="mb-3">{{ $t('unanswered_msg_info') }}</h1>
        <div class="my-2">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 sm6>
              <v-btn
                depressed
                :outline="channelFilter != 'all'"
                :color="channelFilter == 'all' ? 'primary' : 'grey'"
                @click="handleChangeChannel('all')"
                class="ma-0 mr-1 mb-1"
                >{{ $t('All') }}</v-btn
              >
              <v-btn
                depressed
                :outline="channelFilter != 'facebook'"
                :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
                @click="handleChangeChannel('facebook')"
                class="ma-0 mr-1 mb-1"
              >
                <em class="fab fa-facebook-square mr-1" />
                {{ $t('Facebook') }}
              </v-btn>
              <v-btn
                depressed
                :outline="channelFilter != 'line'"
                :color="channelFilter == 'line' ? 'primary' : 'grey'"
                @click="handleChangeChannel('line')"
                class="ma-0 mr-1 mb-1"
              >
                <em class="fab fa-line mr-1" />
                {{ $t('Line') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div class="mb-2">
          <DateFilter
            @changeDate="handleGetUnansweredMessage"
            :defaultFilter="'last_7_days'"
            :showTime="true"
            v-model="selectedDate"
          ></DateFilter>
        </div>
        <div class="mb-2">
          <v-layout wrap>
            <v-flex xs12>
              <div class="primary--text">Customer sentence</div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="default-input">
                <v-text-field
                  name="search"
                  single-line
                  :placeholder="$t('Search')"
                  id="search"
                  v-model="search"
                  outline
                  clearable
                  prepend-inner-icon="search"
                  hide-details
                  @blur="onSearch"
                  @keydown.enter="onSearch"
                  @input="onSearch"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs12 sm6 class="text-sm-right text-xs-right">
              <v-btn
                dark
                outline
                color="primary"
                @click="handleExportXlsx"
                :loading="loadingExport"
              >
                <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="sentenceData"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <v-btn
                  @click.stop="goToLivechat(props.item, props.item.channel)"
                  icon
                  outline
                  color="primary"
                >
                  <em class="fas fa-comments" />
                </v-btn>
              </td>
              <td>{{ props.item.sentence }}</td>
              <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
              <td class="text-xs-center">
                <span style="color: #3b5998" v-if="props.item.channel == 'facebook'">
                  <em class="fab fa-facebook-square" />
                </span>
                <span style="color: #00c300" v-else-if="props.item.channel == 'line'">
                  <em class="fab fa-line" />
                </span>
              </td>
              <td>{{ handleGetDateTimeFormatted(props.item.timestamp) }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleNextPage"
            :length="pagelength"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import bbqApi from '@/api/bbq'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import XLSX from 'xlsx'
import { DATETIME } from '@/constants/datetime.js'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      channelFilter: 'all',
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      sentenceData: [],
      headers: [
        { text: '', sortable: false },
        { text: 'Sentence', value: 'sentence', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Period', value: 'period', sortable: false }
      ],
      search: '',
      isExport: false,
      loadingExport: false,
      searchTimeout: null
    }
  },
  async mounted() {
    await this.handleGetUnansweredMessage()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    handleFetchData() {
      this.offset = 0
      this.limit = 10
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetUnansweredMessage()
    },
    async handleGetUnansweredMessage() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getUnansweredMessage()
        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.sentenceData = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getUnansweredMessage() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          channel: vm.channelFilter,
          date_from: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          date_to: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          keyword: vm.search || undefined
        }

        const response = await bbqApi.getUnansweredMessage({
          config: {
            params: data
          }
        })
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      vm.loadingExport = true
      const responseUnansweredMessage = await vm.getUnansweredMessage()
      const sentenceData = responseUnansweredMessage.data.data
      vm.isExport = false
      vm.loadingExport = false

      if (sentenceData == null) return
      const dataWs = sentenceData.map((el) => {
        return {
          sentence: el.sentence,
          name: `${el.first_name} ${el.last_name}`,
          channel: el.channel,
          period: moment(el.timestamp).format('YYYY-MM-DD HH:ss')
        }
      })

      const heading = [['Sentence', 'Name', 'Channel', 'Period']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, dataWs, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `unanswered-message-info.xlsx`)
    },
    handleNextPage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleGetUnansweredMessage()
      }
    },
    handleGetDateTimeFormatted(value) {
      return value ? moment(value).format(DATETIME.DATETIME_FORMAT_DISPLAY) : ''
    },
    goToLivechat: function (user, app) {
      console.log('user: ', user)
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.id,
          user: user.context == 'contactadmin' ? 'admin' : 'bot',
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleChangeChannel(val) {
      this.channelFilter = val
      this.handleGetUnansweredMessage()
    },
    onSearch() {
      const vm = this
      if (vm.searchTimeout) {
        clearTimeout(vm.searchTimeout)
      }
      if (vm.loading) return false
      vm.searchTimeout = setTimeout(async () => {
        vm.loading = true
        try {
          vm.offset = 0
          vm.pageNumber = 1
          vm.timestamp = moment().format('x')
          await vm.handleGetUnansweredMessage()
        } catch (error) {
          console.error(error)
        }
        vm.loading = false
        vm.searchTimeout = null
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Bbq/UnansweredMsgInfo.vue